import menu from "./menu";
import company from "./company";
import fileUploader from './file-uploader'

const constants = {
  menu,
  company,
  fileUploader
};

export default constants;
